// extracted by mini-css-extract-plugin
export default {"bodyText":"BodyText_bodyText__-6oP1","large":"BodyText_large__MdQhm","small":"BodyText_small__xNZul","fullWidth":"BodyText_fullWidth__djbE0"};